import Modal from "../../../../../../src/entities/UI/Modal/Modal";
import { EnumEventBus, eventBus } from "../../managers/EventBus";
import { QuestionMode } from "../../types/Enum";
import TestModeModalRenderer from "./TestModeModalRenderer";


export default class TestModeModal {
  private Modal!: Modal;
  private TestModalRenderer!: TestModeModalRenderer;

  constructor() {
    const size = { width: 420, height: 240 };
    this.initTestModalRenderer();
    this.Modal = new Modal(this.TestModalRenderer, size, false);
    eventBus.on(EnumEventBus.setQuestMode, (mode: QuestionMode) => this.setModal(mode));
  }

  initTestModalRenderer() {
    const onHandleDownStartButton = () => {
      this.Modal.hideModal();
      eventBus.emit(EnumEventBus.startTest);
    };
    this.TestModalRenderer = new TestModeModalRenderer(
      () => onHandleDownStartButton()
    )
  }
  setModal(mode: QuestionMode) {
    mode == QuestionMode.test ? this.Modal.openModal() : this.Modal.hideModal();
  }
}
